import React, { useEffect, createElement, Component } from 'react';
import { Toaster } from 'sonner';
import { CONSTANTS } from './utils/constants';
// Components
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { EmotionalTransition } from './components/EmotionalTransition';
import { ProductPresentation } from './components/ProductPresentation';
import { RecipeGallery } from './components/RecipeGallery';
import { WhatIsIncluded } from './components/WhatIsIncluded';
import { PackComposite } from './components/PackComposite';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TrustBar } from './components/TrustBar';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { CountdownTimer } from './components/CountdownTimer';
// Declare global for Meta Pixel
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    try {
      !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', CONSTANTS.PIXEL_ID);
      window.fbq('track', 'PageView');
    } catch (error) {
      console.error('Meta Pixel initialization failed', error);
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-0">
      <Toaster data-id="element-1" />
      <PurchasePopup data-id="element-2" />
      <StickyBar data-id="element-3" />

      <main data-id="element-4">
        <HeroSection data-id="element-5" />
        <SocialProof data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <EmotionalTransition data-id="element-8" />
        <RecipeGallery data-id="element-9" />
        <ProductPresentation data-id="element-10" />
        <WhatIsIncluded data-id="element-11" />
        <PackComposite data-id="element-12" />
        <BonusSection data-id="element-13" />
        <UrgencySection data-id="element-14" />
        <OfferSection data-id="element-15" />
        <TestimonialsSection data-id="element-16" />
        <GuaranteeSection data-id="element-17" />
        <TrustBar data-id="element-18" />
        <FAQSection data-id="element-19" />

        {/* Final CTA Section */}
        <section className="py-20 px-4 bg-blue-900 text-center text-white" data-id="element-20">
          <div className="max-w-3xl mx-auto" data-id="element-21">
            <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-22">
              🚀 ORA TOCCA A TE
            </h2>
            <p className="text-xl text-blue-200 mb-10" data-id="element-23">
              Accedi subito e inizia oggi.
            </p>

            <div className="flex justify-center mb-10" data-id="element-24">
              <CountdownTimer variant="light" className="scale-125" data-id="element-25" />
            </div>

            <a href={CONSTANTS.PAYMENT_LINK} target="_blank" rel="noopener noreferrer" className="inline-block bg-green-500 hover:bg-green-600 text-white rounded-full py-5 px-10 font-bold text-xl md:text-2xl shadow-[0_0_30px_rgba(34,197,94,0.5)] transition-all transform hover:scale-105 animate-pulse-fast w-full md:w-auto" data-id="element-26">
              SÌ, VOGLIO IL PACCHETTO COMPLETO
            </a>
          </div>
        </section>
      </main>

      <Footer data-id="element-27" />
    </div>;
}